export default __webpack_public_path__ + "static/media/POD-19.f2b45c1c.jpg";